import {apiTaskToCreationSingleVoyage} from "@containers/singleVoyage/tasks/helpers/executions";
import React, {Suspense, useMemo} from 'react';

import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import ErrorBlock from "@ui/errors/errorBlock/ErrorBlock";
import {useTranslation} from 'react-i18next';
import MutateSingleVoyage from "@containers/singleVoyage/mutateVoyage/MutateSingleVoyage";
import {useAppContext} from "@context/appContext/hooks/useAppContext";
import {
    getInitialMutateVoyagePropsFromSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/helpers/getInitialMutateVoyagePropsFromSingleVoyage";
import {useGetTasksSingleVoyageQuery} from "@containers/singleVoyage/tasks/queryHooks/useTasksSingleVoyageQuery";
import {useGetByIdSingleVoyageQuery} from "@containers/singleVoyage/fetchingData/queryHooks/useSingleVoyagesQuery";
import {
    useGetInitialAccountIdSingleVoyage
} from "@containers/singleVoyage/account/hooks/useGetInitialAccountIdSingleVoyage";

interface IProps {
    voyageId: number
}

const UpdateSingleVoyage = ({voyageId}: IProps) => {

    const {t} = useTranslation()
    const {account} = useAppContext()

    const accountId = useGetInitialAccountIdSingleVoyage()

    const {
        data,
        isLoading,
        isFetching,
        isError,
    } = useGetByIdSingleVoyageQuery({
        params: {
            voyageId,
            accountId,
        },
        refetchOnMount: 'always'
    })

    const {
        data: tasks,
        isLoading: isLoadingGetTasks,
        isFetching: isFetchingGetTasks,
    } = useGetTasksSingleVoyageQuery({
        params: {
            voyageId,
            accountId
        }
    })


    const initial = useMemo(() => {
        return getInitialMutateVoyagePropsFromSingleVoyage(data)
    }, [data])

    if (
        isLoading ||
        isFetching ||
        isLoadingGetTasks ||
        isFetchingGetTasks
    ) {
        return (
            <SpinnerCustom
                variant={'fullScreen'}
            />
        )
    }

    if (!data?.id || isError) {
        return (
            <ErrorBlock
                message={t('singleVoyage.notFoundVoyage')}
            />

        )
    }

    return (
        <Suspense
            fallback={<SpinnerCustom/>}
        >
            <MutateSingleVoyage
                initialPositions={initial?.initialPositions}
                initialRouteInfo={initial?.initialRouteInfo}
                initialPoints={initial?.initialPoints}
                initialTasks={(tasks ?? []).map(apiTaskToCreationSingleVoyage)}
                voyageId={data.id}
            />
        </Suspense>
    )
};

export default UpdateSingleVoyage;
